import { Colors, FlexBox, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const Outer = styled.div.attrs({
    className: "team-edit-panel"
})`
    position: fixed;
    bottom: 32px;
    left: 0;
    width: 100%;
    z-index: 100;
    background-color: ${Colors.galBlack5};
`;

export const SimplyPanelContainer = styled(FlexBox)`
    width: 100%;
    padding: 16px 0;
    margin: 0 auto;
    max-width: ${LayoutConst.container.l}px;
    flex-flow: row;
    gap: 24px;
    justify-content: space-between;
    place-items: center;

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const SimplyButtonsWrapper = styled(FlexBox)`
    gap: 16px;
    flex-flow: row;
    
`;

export const Text = styled.span`
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
    color: ${Colors.galBlack100};
`;

export const HeadText = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    color: ${Colors.galBlack100};
`;

export const BottoMText = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: ${Colors.galBlack100};
`;

export const TabPanelContainer = styled(FlexBox)<{ disableMargin?: boolean}>`
    width: 100%;
    flex-flow: column;
    margin-bottom: ${({ disableMargin }) => disableMargin ? '0px' : '32px'};
    gap: 8px;
    max-width: 100%;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: calc(100vw - 20px);
        margin: 0 auto;
    }
`;

export const TabPanelHeader = styled.div`
    font-size: 43px;
    line-height: 51px;
    font-weight: 600;
    white-spae: nowrap;
    color: ${({ theme }) => theme.panel.title};

    @media ${MEDIA.TABLET} {
        font-size: 30px;
        line-height: 40px;
    }
    @media ${MEDIA.MOBILE} {
        font-size: 20px;
        line-height: 25px;
    }
`;

export const TabPanelHeaderContainer= styled(FlexBox)`
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    @media ${MEDIA.MOBILE} {
        flex-flow: column;
        align-items: flex-start;
        gap: 16px;
    }
`;

/** Обёртка кнопки сохранения: data-tip на родителе, hover работает при disabled (как NavbarCreate). */
export const TabPanelSaveButtonWrapper = styled.div<{
    $fullWidth?: boolean;
    $blockChildPointerEvents?: boolean;
}>`
    display: flex;
    flex-flow: row;
    gap: 16px;
    width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

    ${({ $blockChildPointerEvents }) =>
        $blockChildPointerEvents &&
        `
        & > * {
            pointer-events: none;
        }
    `}

    .tooltip-navbar-create {
        ::before,::after {
            display: none;
        }
    }
`;import { Colors, FlexBox, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const Outer = styled.div.attrs({
    className: "team-edit-panel"
})`
    position: fixed;
    bottom: 32px;
    left: 0;
    width: 100%;
    z-index: 100;
    background-color: ${Colors.galBlack5};
`;

export const SimplyPanelContainer = styled(FlexBox)`
    width: 100%;
    padding: 16px 0;
    margin: 0 auto;
    max-width: ${LayoutConst.container.l}px;
    flex-flow: row;
    gap: 24px;
    justify-content: space-between;
    place-items: center;

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const SimplyButtonsWrapper = styled(FlexBox)`
    gap: 16px;
    flex-flow: row;
    
`;

export const Text = styled.span`
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
    color: ${Colors.galBlack100};
`;

export const HeadText = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    color: ${Colors.galBlack100};
`;

export const BottoMText = styled.div`
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: ${Colors.galBlack100};
`;

export const TabPanelContainer = styled(FlexBox)<{ disableMargin?: boolean}>`
    width: 100%;
    flex-flow: column;
    margin-bottom: ${({ disableMargin }) => disableMargin ? '0px' : '32px'};
    gap: 8px;
    max-width: 100%;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        max-width: calc(100vw - 20px);
        margin: 0 auto;
    }
`;

export const TabPanelHeader = styled.div`
    font-size: 43px;
    line-height: 51px;
    font-weight: 600;
    white-spae: nowrap;
    color: ${({ theme }) => theme.panel.title};

    @media ${MEDIA.TABLET} {
        font-size: 30px;
        line-height: 40px;
    }
    @media ${MEDIA.MOBILE} {
        font-size: 20px;
        line-height: 25px;
    }
`;

export const TabPanelHeaderContainer= styled(FlexBox)`
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    @media ${MEDIA.MOBILE} {
        flex-flow: column;
        align-items: flex-start;
        gap: 16px;
    }
`;

/** Обёртка кнопки сохранения: data-tip на родителе, hover работает при disabled (как NavbarCreate). */
export const TabPanelSaveButtonWrapper = styled.div<{
    $fullWidth?: boolean;
    $blockChildPointerEvents?: boolean;
}>`
    display: flex;
    flex-flow: row;
    gap: 16px;
    width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

    ${({ $blockChildPointerEvents }) =>
        $blockChildPointerEvents &&
        `
        & > * {
            pointer-events: none;
        }
    `}

    .tooltip-navbar-create {
        ::before,::after {
            display: none;
        }
    }
`;